import React from 'react'
import { useRouter } from 'next/router'

const useProjectId = () => {
  const { pathname, query } = useRouter()
  const projectId = query?.projectId || query['project-id']

  return React.useMemo(() => {
    if (!pathname && !projectId)
      throw new Error(
        'Unable to get valid projectId from *useProjectId()* hook. There was an error with either the url pathname or the path parameters.',
      )

    if (projectId) {
      return Array.isArray(projectId) ? projectId[0] : projectId
    }

    const filterableRegex = /\/(app\/projects|shared_project)\/(.+)\/(.+)?/
    return (pathname.match(filterableRegex) || [])[2]
  }, [pathname, projectId])
}

export default useProjectId
